import { createNamespace } from "Common/namespaceUtils/namespaceRedux";
import { NAMESPACE as PARENT_NAMESPACE } from "../constants";
export const NAMESPACE = "contentUpload";
export const FULL_NAMESPACE = createNamespace(PARENT_NAMESPACE, NAMESPACE);
export { PARENT_NAMESPACE as PAGE_NAMESPACE };
export const NEW_FOLDER = {
    Id: 0,
    Name: "",
    DocumentId: 0
};
export const requiredFields = ["Name", "DocumentId"];
export const folderBlockIdPrefix = "contentFolderBlock_";
